import { useSelector } from "react-redux";
import MomentosNavabr from "../components/MomentosNavabr";
import { useHistory } from "react-router-dom";

const Auth = (props) => {
    const { uid, user } = useSelector((state) => state.authUser);
    const history = useHistory();
    const urlParams = new URLSearchParams(window.location.search);
    const redirectPath = urlParams.get("redirect");
    console.log(redirectPath);
    if (uid) {
        if (user?.role == "fan") {
            if (redirectPath) {
                window.location.href = redirectPath;
            } else {
                history.push("/main/gallery");
            }
        } else {
            if (redirectPath) {
                window.location.href = redirectPath;
            } else {
                history.push("/main/index");
            }
        }
    }
    return (
        <>
            {/* <header>Auth Header</header> */}
            <MomentosNavabr />
            <div>{props.children}</div>
            {/* <footer>Auth Footer</footer> */}
        </>
    );
};

export default Auth;
